enum OperationStateTypesEnum {
	DONE = 'done',
	ERROR = 'error',
	PENDING = 'pending',
	SUBMITTING = 'submitting',
	NONE = 'none',
	UNAUTHORIZED = 'unauthorized',
	UNAVAILABLE = 'unavailable',
	OPEN_SCHEDULING = 'open_scheduling',
}

type OperationStateType =
	| 'done'
	| 'error'
	| 'pending'
	| 'submitting'
	| 'none'
	| 'unauthorized'
	| 'unavailable'
	| 'open_scheduling';

export {OperationStateTypesEnum};
export type {OperationStateType};
